import {
  SHOPPING_CART_ABORT_PAYMENT,
  SHOPPING_CART_ADD_ITEM,
  SHOPPING_CART_FAIL_PAYMENT,
  SHOPPING_CART_REMOVE_ITEM,
  SHOPPING_CART_START_PAYMENT,
  SHOPPING_CART_SUCCESS_PAYMENT,
  CartActions,
  SHOPPING_CART_UPDATE_PRICING
} from './types'
import { CartItemsType, CartItemType } from '../../types'

export const cartAddItemAction = (payload: CartItemType): CartActions => ({
  type: SHOPPING_CART_ADD_ITEM,
  payload
})

export const cartRemoveItemAction = (payload: {
  id: string;
  type: CartItemsType;
}): CartActions => ({
  type: SHOPPING_CART_REMOVE_ITEM,
  payload
})

export const cartUpdatePricingAction = (payload: { id: string; priceId: string }): CartActions => ({
  type: SHOPPING_CART_UPDATE_PRICING,
  payload
})

export const cartStartPaymentAction = (): CartActions => ({ type: SHOPPING_CART_START_PAYMENT })

export const cartSuccessPaymentAction = (): CartActions => ({ type: SHOPPING_CART_SUCCESS_PAYMENT })

export const cartFailPaymentAction = (payload: string): CartActions => ({
  type: SHOPPING_CART_FAIL_PAYMENT,
  payload
})

export const cartAbortPaymentAction = (): CartActions => ({ type: SHOPPING_CART_ABORT_PAYMENT })
